'use client';

import { type MotionValue, useMotionValueEvent } from 'motion/react';
import { useState } from 'react';

import { Button } from '@/components/ui/button';

function ElapsedClock({
  simTime,
  cap,
}: {
  simTime: MotionValue<number>;
  cap: number;
}) {
  const [seconds, setSeconds] = useState(0);

  useMotionValueEvent(simTime, 'change', (t) => {
    const rounded = Math.min(Math.round(t), cap);
    setSeconds((current) => (current === rounded ? current : rounded));
  });

  return (
    <span className="ml-auto font-mono text-xs text-muted-foreground">
      elapsed{' '}
      <b className="text-sm font-semibold text-foreground tabular-nums">
        {seconds}s
      </b>
    </span>
  );
}

/**
 * One button and a clock. The scrubber below is the only other control: the
 * insight should not depend on operating an interface, so speed switches and
 * a separate reset are gone (replay restarts from zero).
 */
export function RaceControls({
  playLabel,
  simTime,
  cap,
  onPlay,
}: {
  playLabel: string;
  simTime: MotionValue<number>;
  cap: number;
  onPlay: () => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-edge px-3 py-2.5">
      {/* Custom sounds fire from the race container; mute the global click. */}
      <Button size="sm" data-sfx-managed="" onClick={onPlay}>
        {playLabel}
      </Button>

      <ElapsedClock simTime={simTime} cap={cap} />
    </div>
  );
}
